import { useParams } from 'react-router-dom';

import useAppSelector from '@webclient/hooks/useAppSelector';

export default function useEnsureSearchThreadId() {
  const { id } = useParams<{ id: string }>();
  const threadId = useAppSelector((state) => state.searchSession.threadId);

  return threadId || id;
}
